module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('strong', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfms"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/pro.htm"
    }
  }, [_vm._v("Prologue: How Camest Thou in This Pickle?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_c('strong', [_vm._v("Chapter One:")]), _vm._v(" "), _c('br'), _vm._v("Hang Not on My Garments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Two:")]), _vm._v(" "), _c('br'), _vm._v("O Brave New World")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Three:")]), _vm._v(" "), _c('br'), _vm._v("What a Spendthrift Is He of His Tongue")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Four:")]), _vm._v(" "), _c('br'), _vm._v("Good Wombs Have Borne Bad Sons")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Five:")]), _vm._v(" "), _c('br'), _vm._v("Now My Charms Are All O’erthrown")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Six:")]), _vm._v(" "), _c('br'), _vm._v("These Are Not Natural Events")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Seven:")]), _vm._v(" "), _c('br'), _vm._v("Come, Temperate Nymphs, and Help to Celebrate")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Eight:")]), _vm._v(" "), _c('br'), _vm._v("All Men Idle, All. And Women Too")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Nine:")]), _vm._v(" "), _c('br'), _vm._v("Make Yourself Ready … For the Mischance of the Hour")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Ten:")]), _vm._v(" "), _c('br'), _vm._v("They’ll Take Suggestion as a Cat Laps Milk")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Eleven:")]), _vm._v(" "), _c('br'), _vm._v("Now I Will Believe That There Are Unicorns")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c12.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Twelve:")]), _vm._v(" "), _c('br'), _vm._v("The Rarer Action Is in Virtue Than in Vengeance")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c13.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Thirteen:")]), _vm._v(" "), _c('br'), _vm._v("Unless I Be Reliev’d by Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c14.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Fourteen:")]), _vm._v(" "), _c('br'), _vm._v("A Thousand Twangling Instruments Will Hum about Mine Ears")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c15.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Fifteen:")]), _vm._v(" "), _c('br'), _vm._v("You Cram These Words Into Mine Ears Against the Stomach of My Sense")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c16.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Sixteen:")]), _vm._v(" "), _c('br'), _vm._v("Sweet Lord, You Play Me False")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c17.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Seventeen:")]), _vm._v(" "), _c('br'), _vm._v("Untie the Spell")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c18.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Eighteen:")]), _vm._v(" "), _c('br'), _vm._v("’Tis a Villain, Sir, I Do Not Love to Look On")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c19.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Nineteen")]), _vm._v(":"), _c('br'), _vm._v("\nHark! Now I Hear Them — Ding-Dong, Bell")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c20.htm"
    }
  }, [_c('strong', [_vm._v("Chapter Twenty:")]), _vm._v(" "), _c('br'), _vm._v("We Are Such Stuff as Dreams Are Made On")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsfm"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cop.htm"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349bca82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 63
// module chunks = 0